import { useEffect } from 'react'
import { initDatadogLogging } from '~/utils/datadog'

const DatadogInit = () => {
  useEffect(() => {
    initDatadogLogging()
  }, [])

  return null
}

export default DatadogInit
